var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('core-filter-config',{attrs:{"state":_vm.is,"loginRequired":true,"selfOnly":true},on:{"expand":_vm.onExpandClick,"close":_vm.onCloseClick,"save":_vm.onSaveClick}},[_c('app-config-template-plays-usernames')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }